import { Navigate, Route, Routes } from 'react-router-dom';

import { DefaultLayout2, GuardScope, useAccessGuard } from '@web/app/shared';

import { MemberListPage } from '../pages/list';

export const TeamRoutes = () => {
    useAccessGuard(GuardScope.Workspace);

    return (
        <Routes>
            <Route element={<DefaultLayout2 />}>
                <Route path="/" element={<MemberListPage />} />
                <Route path="*" element={<Navigate to="../.." replace></Navigate>}></Route>
            </Route>
        </Routes>
    );
};
